import React from 'react';
import { Typography } from '@fiverr-private/typography';
import type { DropzoneProps } from '../types';
import { getDisclaimerMessage } from './utils';

const Disclaimer = ({
  showDisclaimer,
  maxSize,
  accept,
  maxFiles,
  theme,
}: Pick<DropzoneProps, 'showDisclaimer' | 'maxSize' | 'accept' | 'maxFiles' | 'theme'>) => {
  let message = '';
  if (showDisclaimer) {
    message = getDisclaimerMessage({ maxSize, maxFiles, accept });
  }

  if (!message) {
    return null;
  }

  return (
    <Typography
      color={theme === 'dark' ? 'grey_300' : 'bodySecondary'}
      size="b_sm"
      textAlign="center"
      whiteSpace="preWrap"
    >
      {message}
    </Typography>
  );
};

Disclaimer.displayName = 'Disclaimer';

export default Disclaimer;
